module.exports = __webpack_public_path__ + "media/images/blank-d55fa53307d00568d0ce577ccf42b82f.png";